export default __webpack_public_path__ + "static/media/refpay.d57f6428.svg";